import app from '../app';

import adAssessmentTemplate from '../../blocks/modals/modal-ad-assessment/modal-ad-assessment.jade';
import modalAdAssessmentCtrl from '../../blocks/modals/modal-ad-assessment/modal-ad-assessment.controller';
import reportAddressTemplate from '../../blocks/modals/modal-report-address/modal-report-address.jade';
import modalReportAddressCtrl from '../../blocks/modals/modal-report-address/modal-report-address.controller';
import reportFormTemplate from '../../blocks/modals/modal-report-form/modal-report-form.jade';
import modalReportFormCtrl from '../../blocks/modals/modal-report-form/modal-report-form.controller';
import reportErrorTemplate from '../../blocks/modals/modal-report-error/modal-report-error.jade';
import modalReportErrorCtrl from '../../blocks/modals/modal-report-error/modal-report-error.controller';
import reportCheckPublishErrorTemplate from '../../blocks/modals/modal-report-check-publish-error/modal-report-check-publish-error.jade';
import rulesTemplate from '../../blocks/modals/modal-rules/modal-rules.jade';
import pubAvailTemplate from '../../blocks/modals/modal-pub-avail/modal-pub-avail.jade';
import pubAvailCtrl from '../../blocks/modals/modal-pub-avail/modal-pub-avail.controller';
import jkAddTemplate from '../../blocks/modals/modal-jk-add/modal-jk-add.jade';
import jkAddCtrl from '../../blocks/modals/modal-jk-add/modal-jk-add.controller';
import serverErrorModalTemplate from '../../blocks/modals/modal-server-error/modal-server-error.jade';
import refillBalanceTemplate from '../../blocks/modals/modal-refill-balance/modal-refill-balance.jade';
import refillBalanceCtrl from '../../blocks/modals/modal-refill-balance/refill-balance.controller';
import refillAgencyBalanceTemplate from '../../blocks/modals/modal-refill-agency-balance/modal-refill-agency-balance.jade';
import refillAgencyBalanceCtrl from '../../blocks/modals/modal-refill-agency-balance/refill-agency-balance.controller';
import validationErrorTemplate from '../../blocks/modals/modal-validation-error/modal-validation-error.jade';
import validationErrorCtrl from '../../blocks/modals/modal-validation-error/modal-validation-error.controller';
import identificationErrorTemplate from '../../blocks/modals/modal-identification-error/modal-identification-error.jade';
import identificationErrorCtrl from '../../blocks/modals/modal-identification-error/modal-identification-error.controller';
import activeDraftCtrl from '../../blocks/modals/modal-active-draft/modal-active-draft.controller';
import activeDraftTemplate from '../../blocks/modals/modal-active-draft/modal-active-draft.jade';
import upsaleHighlightCtrl from '../../blocks/modals/modal-upsale-highlight/modal-upsale-highlight.controller';
import upsaleHighlightTemplate from '../../blocks/modals/modal-upsale-highlight/modal-upsale-highlight.jade';
import upsaleHighlightSuccessTemplate from '../../blocks/modals/modal-upsale-highlight-success/modal-upsale-highlight-success.jade';
import upsaleHighlightFailureTemplate from '../../blocks/modals/modal-upsale-highlight-failure/modal-upsale-highlight-failure.jade';

import modalReportMessageOkTemplate from '../../blocks/modals/modal-report-message-ok/modal-report-message-ok.jade';
import modalReportMessageOkCtrl from '../../blocks/modals/modal-report-message-ok/modal-report-message-ok.controller';
import modalReportMessageErrorTemplate from '../../blocks/modals/modal-report-message-error/modal-report-message-error.jade';
import modalReportMessageErrorCtrl from '../../blocks/modals/modal-report-message-error/modal-report-message-error.controller';

import authErrorCtrl from '../../blocks/modals/modal-auth-error/modal-auth-error.controller';
import authErrorTemplate from '../../blocks/modals/modal-auth-error/modal-auth-error.jade';

import modalPayByCardCtrl from '../../blocks/modals/modal-pay-by-card/pay-by-card.controller';
import payByCardTemplate from '../../blocks/modals/modal-pay-by-card/pay-by-card.jade';

import modalYandexPayCtrl from '../../blocks/modals/modal-yandex-pay/yandex-pay.controller';
import yandexPayTemplate from '../../blocks/modals/modal-yandex-pay/yandex-pay.jade';

import advertiseObjectCtrl from '../../blocks/modals/modal-advertise-object/advertise-object.controller';
import advertiseObjectTemplate from '../../blocks/modals/modal-advertise-object/advertise-object.jade';

import modalPremoderationConfirmCtrl from '../../blocks/modals/modal-premoderation-confirm/modal-premoderation-confirm.controller';
import premoderationConfirmTemplate from '../../blocks/modals/modal-premoderation-confirm/modal-premoderation-confirm.jade';

import auctionConfirmCtrl from '../../blocks/modals/modal-auction-confirm/modal-auction-confirm.controller';
import auctionConfirmTemplate from '../../blocks/modals/modal-auction-confirm/modal-auction-confirm.jade';

import ivrRemindCtrl from '../../blocks/modals/modal-ivr-remind/modal-ivr-remind.controller';
import ivrRemindTemplate from '../../blocks/modals/modal-ivr-remind/modal-ivr-remind.jade';

import auctionAddCtrl from '../../blocks/modals/modal-auction-add/modal-auction-add.controller';
import auctionAddTemplate from '../../blocks/modals/modal-auction-add/modal-auction-add.jade';

import auctionIncreaseCtrl from '../../blocks/modals/modal-auction-increase/modal-auction-increase.controller';
import auctionIncreaseTemplate from '../../blocks/modals/modal-auction-increase/modal-auction-increase.jade';

import modalTarifsTemplate from '../../blocks/modals/modal-tarifs/modal-tarifs.jade';
import modalTarifsCtrl from '../../blocks/modals/modal-tarifs/modal-tarifs.controller';

import modalHintTemplate from '../../blocks/modals/modal-hint/modal-hint.jade';
import modalHintCtrl from '../../blocks/modals/modal-hint/modal-hint.controller';

import homeownerHintTemplate from '../../blocks/modals/modal-homeowner-hint/modal-homeowner-hint.jade';

import modalDealRentTrapAfterFpTemplate from '../../blocks/modals/modal-deal-rent-trap-after-fp/modal-deal-rent-trap-after-fp.jade';
import modalDealRentTrapAfterFpCtrl from '../../blocks/modals/modal-deal-rent-trap-after-fp/modal-deal-rent-trap-after-fp.controller';

import fullscreenPlanPreviewTemplate from '../../blocks/modals/modal-fullscreen-plan-preview/modal-fullscreen-plan-preview.jade';
import fullscreenPlanPreviewCtrl from '../../blocks/modals/modal-fullscreen-plan-preview/modal-fullscreen-plan-preview.controller';

import {
  PackageBuyConfirmationModalTemplate,
  PackageBuyConfirmationModalController,
} from '../../blocks/modals/PackageBuyConfirmationModal';

import {
  PackageBuyResultModalTemplate,
  PackageBuyResultModalController,
} from '../../blocks/modals/PackageBuyResultModal';

import modalDealRentTrapInFpTemplate from '../../blocks/modals/modal-deal-rent-trap-in-fp/modal-deal-rent-trap-in-fp.jade';
import modalDealRentTrapInFpCtrl from '../../blocks/modals/modal-deal-rent-trap-in-fp/modal-deal-rent-trap-in-fp.controller';

import {
  DealRentSelfEmployedTrapTemplate,
  DealRentSelfEmployedTrapController,
 } from '../../blocks/modals/modal-deal-rent-self-employed-trap';
import { OPEN_MODAL } from '../../../../shared/actions';

 import {
  DealRentTrapInFpConfirmTemplate,
  DealRentTrapInFpConfirmController,
 } from '../../blocks/modals/modal-deal-rent-trap-in-fp-confirm';


app.factory('popupService', ['$uibModal', 'deviceService', ($uibModal, deviceService) => {
  const modals = {
    dealRentTrapAfterFp: {
      template: modalDealRentTrapAfterFpTemplate,
      controller: modalDealRentTrapAfterFpCtrl,
      controllerAs: 'modalDealRentTrapAfterFp',
    },
    dealRentTrapInFp: {
      template: modalDealRentTrapInFpTemplate,
      controller: modalDealRentTrapInFpCtrl,
      controllerAs: 'modalDealRentTrapInFp',
    },
    dealRentTrapInFpConfirm: {
      template: DealRentTrapInFpConfirmTemplate,
      controller: DealRentTrapInFpConfirmController,
      controllerAs: 'modalDealRentTrapInFpConfirm',
    },
    dealRentSelfEmployedTrap: {
      template: DealRentSelfEmployedTrapTemplate,
      controller: DealRentSelfEmployedTrapController,
      controllerAs: 'modalDealRentSelfEmployedTrap',
    },
    hint: {
      template: modalHintTemplate,
      controller: modalHintCtrl,
      controllerAs: 'modalHint',
    },
    reportMessageOk: {
      template: modalReportMessageOkTemplate,
      controller: modalReportMessageOkCtrl,
      controllerAs: 'modalReportMessageOk',
    },
    reportMessageError: {
      template: modalReportMessageErrorTemplate,
      controller: modalReportMessageErrorCtrl,
      controllerAs: 'modalReportMessageError',
    },
    adAssessment: {
      template: adAssessmentTemplate,
      controller: modalAdAssessmentCtrl,
      controllerAs: 'modalAdAssessmentCtrl',
    },
    reportForm: {
      template: reportFormTemplate,
      controller: modalReportFormCtrl,
      controllerAs: 'modalReportFormCtrl',
    },
    reportError: {
      template: reportErrorTemplate,
      controller: modalReportErrorCtrl,
      controllerAs: 'modalReportErrorCtrl',
    },
    reportAddress: {
      template: reportAddressTemplate,
      controller: modalReportAddressCtrl,
      controllerAs: 'modalReportAddressCtrl',
    },
    tarifs: {
      template: modalTarifsTemplate,
      controller: modalTarifsCtrl,
      controllerAs: 'modalTarifsCtrl',
    },
    adRules: {
      template: rulesTemplate,
    },
    pubAvail: {
      template: pubAvailTemplate,
      controller: pubAvailCtrl,
      controllerAs: 'pubAvailCtrl',
    },
    jkAdd: {
      template: jkAddTemplate,
      controller: jkAddCtrl,
      controllerAs: 'jkAddCtrl',
    },
    serverError: {
      template: serverErrorModalTemplate,
    },
    refillBalance: {
      template: refillBalanceTemplate,
      controller: refillBalanceCtrl,
      controllerAs: 'refillBalanceCtrl',
    },
    refillAgencyBalance: {
      template: refillAgencyBalanceTemplate,
      controller: refillAgencyBalanceCtrl,
      controllerAs: '$ctrl',
    },
    validationError: {
      template: validationErrorTemplate,
      controller: validationErrorCtrl,
      controllerAs: 'validationErrorCtrl',
    },
    // При попытке идентификации по паспорту произошла ошибка
    identificationError: {
      template: identificationErrorTemplate,
      controller: identificationErrorCtrl,
      controllerAs: 'identificationErrorCtrl',
    },
    // Подтверждение включения/выключения активного черновика
    activeDraft: {
      template: activeDraftTemplate,
      controller: activeDraftCtrl,
      controllerAs: 'activeDraft',
    },
    // Покупка ВЦ на странице успеха
    upsaleHighlight: {
      template: upsaleHighlightTemplate,
      controller: upsaleHighlightCtrl,
      controllerAs: 'upsaleHighlightCtrl',
    },
    upsaleHighlightSuccess: {
      template: upsaleHighlightSuccessTemplate
    },
    upsaleHighlightFailure: {
      template: upsaleHighlightFailureTemplate
    },
    checkPublishError: {
      template: reportCheckPublishErrorTemplate,
    },
    authError: {
      template: authErrorTemplate,
      controller: authErrorCtrl,
      controllerAs: 'authError',
    },
    payByCard: {
      template: payByCardTemplate,
      controller: modalPayByCardCtrl,
      controllerAs: 'modalPayByCardCtrl',
    },
    yandexPay: {
      template: yandexPayTemplate,
      controller: modalYandexPayCtrl,
      controllerAs: 'modalYandexPayCtrl',
    },
    premoderationConfirm: {
      template: premoderationConfirmTemplate,
      controller: modalPremoderationConfirmCtrl,
      controllerAs: 'modalPremoderationConfirmCtrl',
    },
    advertiseObject: {
      template: advertiseObjectTemplate,
      controller: advertiseObjectCtrl,
      controllerAs: 'advertiseObjectCtrl',
    },
    ivrRemind: {
      template: ivrRemindTemplate,
      controller: ivrRemindCtrl,
      controllerAs: 'ivrRemind',
    },
    auctionConfirm: {
      template: auctionConfirmTemplate,
      controller: auctionConfirmCtrl,
      controllerAs: 'auctionConfirmCtrl',
    },
    auctionAdd: {
      template: auctionAddTemplate,
      controller: auctionAddCtrl,
      controllerAs: 'auctionAddCtrl',
    },
    auctionIncrease: {
      template: auctionIncreaseTemplate,
      controller: auctionIncreaseCtrl,
      controllerAs: 'auctionIncreaseCtrl',
    },
    homeownerHint: {
      template: homeownerHintTemplate,
    },
    fullscreenPlanPreview: {
      template: fullscreenPlanPreviewTemplate,
      controller: fullscreenPlanPreviewCtrl,
      controllerAs: 'fullscreenPlanPreviewCtrl',
    },
    PackageBuyConfirmationModal: {
      template: PackageBuyConfirmationModalTemplate,
      controller: PackageBuyConfirmationModalController,
      controllerAs: 'PackageBuyConfirmationModalCtrl',
    },
    PackageBuyResultModal: {
      template: PackageBuyResultModalTemplate,
      controller: PackageBuyResultModalController,
      controllerAs: 'PackageBuyResultModalCtrl',
    },
  };

  const openPopup = (name, data = {}) => {
    const modal = modals[name];

    if (modal && !modal.opened) { // только один открытый попап одного типа в момент времени
      modal.opened = true;
      // Преобразуем объекты в функции, чтобы использовать их в resolve
      Object.keys(data).forEach(key => {
        const value = data[key];
        data[key] = () => value;
      });

      const modalInstance = deviceService.isMobile ?
        $uibModal.open({
          ...modal,
          appendTo: window.$(document).find('.modal-wrapper'),
          openedClass: 'modal-open',
          resolve: {
            ...data,
          },
        }) :
        $uibModal.open({
          ...modal,
          resolve: {
            ...data,
          },
        });

      if (deviceService.isMobile) {
        window.$(document).find('.modal-wrapper').addClass('modal-open');
        window.$(document).find('body').addClass('modal-body-wrapper');
      }

      if (angular.isFunction(modal.onOpened)) {
        modalInstance.opened.then(modal.onOpened);
      }

      if (angular.isFunction(modal.onClosed)) {
        modalInstance.closed.then(modal.onClosed);
      }

      modalInstance.closed.finally(() => {
        modal.opened = false;

        if (deviceService.isMobile) {
          window.$(document).find('.modal-wrapper').removeClass('modal-open');
          window.$(document).find('body').removeClass('modal-body-wrapper');
        }
      });

      return modalInstance;
    }
  };

  const isOpen = (name) => {
    return modals[name].opened;
  }

  document.addEventListener(OPEN_MODAL, function ({ detail }) {
    const { name, data } = detail;

    openPopup(name, data);
  });

  return {
    openPopup,
    isOpen
  };
}]);
